import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="contained-image"
export default class extends Controller {
  static targets = ["img", "wrapper"];

  connect() {
    if (!(this.imgTarget instanceof HTMLImageElement)) {
      return;
    }

    if (this.imgTarget.complete) {
      this.initialize();
      return;
    }

    this.imgTarget.onload = this.initialize.bind(this);
  }

  initialize() {
    if (this.imgTarget.naturalHeight === 0) {
      return;
    }

    this.element.style.opacity = 1;

    this.setImageSize();
    const observer = new ResizeObserver(this.setImageSize.bind(this));
    observer.observe(this.element);
  }

  setImageSize() {
    const availableWidth = this.element.clientWidth;
    const availableHeight = this.element.clientHeight;

    if (availableWidth === 0 || availableHeight === 0) {
      return;
    }

    const availableAspectRatio = availableHeight / availableWidth;

    const imgAspectRatio = this.imgTarget.naturalHeight / this.imgTarget.naturalWidth;

    if (imgAspectRatio > availableAspectRatio) {
      this.wrapperTarget.style.height = `${availableHeight}px`;
      this.wrapperTarget.style.width = `${availableHeight / imgAspectRatio}px`;
    } else {
      this.wrapperTarget.style.width = `${availableWidth}px`;
      this.wrapperTarget.style.height = `${availableWidth * imgAspectRatio}px`;
    }

    this.element.style.opacity = 1;
  }
}
